// ソフトウェア描画のレンダラー名（Chrome の SwiftShader、Mesa の llvmpipe、Windows の Basic Render Driver など）
const SOFTWARE_RENDERER = /swiftshader|llvmpipe|softpipe|software|basic render/i

/**
 * GPU で WebGL を描ける環境か。
 * ソフトウェア描画では1フレームの描画がメインスレッドを数百 ms 塞ぎ続ける。
 * 操作がカクつくうえ、PageSpeed Insights（GPU が無い）の計測が終わらなくなるので除く。
 */
export function supportsWebGL(): boolean {
  try {
    const c = document.createElement('canvas')
    const opts: WebGLContextAttributes = { failIfMajorPerformanceCaveat: true }
    const gl: WebGLRenderingContext | WebGL2RenderingContext | null =
      c.getContext('webgl2', opts) ?? c.getContext('webgl', opts)
    if (!gl) return false
    const info = gl.getExtension('WEBGL_debug_renderer_info')
    const renderer = String(gl.getParameter(info ? info.UNMASKED_RENDERER_WEBGL : gl.RENDERER))
    gl.getExtension('WEBGL_lose_context')?.loseContext()
    return !SOFTWARE_RENDERER.test(renderer)
  } catch {
    return false
  }
}
